import {
  createIntl,
  createIntlCache
} from '@formatjs/intl'
import { appMessages } from '../../messages'
import workoutMessages from '../workout/redux/messages'
import { plansMessages } from '../plans'
import {
  MUSCLE_COMBINATIONS_MESSAGE,
  MUSCLE_MESSAGE
} from '../muscles'
import { EQUIPMENT_MESSAGE } from '../equipment'
import { LEVEL_MESSAGE } from '../../constant'
import { PROFILE_GENDER_MESSAGE } from '../../models'

const localeToIntl = {}

export function createIntlUtil (params = {}) {
  const locale = params.locale || 'en'
  // TODO Handle message key overlaps
  const messages = {
    ...appMessages,
    ...workoutMessages,
    ...plansMessages,
    ...MUSCLE_COMBINATIONS_MESSAGE,
    ...MUSCLE_MESSAGE,
    ...PROFILE_GENDER_MESSAGE,
    ...LEVEL_MESSAGE,
    ...EQUIPMENT_MESSAGE
  }

  const intl = localeToIntl[locale] || createIntl({
    locale,
    messages,
    cache: createIntlCache()
  })

  if (!localeToIntl[locale]) {
    localeToIntl[locale] = intl
  }
  return intl
}

export function formatMessageIntlUtil (intl, message, params = {}) {
  if (!message) {
    console.warn('[notFound]: message not found: ', params)
    return ''
  }

  const formatMessage = intl && intl.formatMessage
  if (!formatMessage) {
    return typeof message === 'object'
      ? message.defaultMessage
      : message
  }

  Object.keys(params)
    .forEach(paramKey => {
      const param = params[paramKey]
      const message = param && param.message
      if (message && typeof message === 'object') {
        params[paramKey] = formatMessage(message)
      }
    })

  return formatMessage(message, {
    ...params,
    br: '\n'
  })
}
